import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { ExtraGuard } from '../../services/guard/extra.guard';

const routes: Routes = [{
  path: '**',
  component: PageNotFoundComponent,
  canActivate: [ExtraGuard]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PageNotFoundModuleRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/page-not-found-module/page-not-found-module-routing.module.ts